export default __webpack_public_path__ + "static/media/TTNormsPro-Regular.a3ddb093.woff2";